import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { Building } from '../../model/building';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaBuildingHttpService extends GenericAkitaHTTPService<Building> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'Building',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'building', options);
  }
}
